import React from "react";
import styled from "styled-components";

const Description = styled.p`
  font-size: 16px;
  padding-top: 5px;
`;

const DivSection = styled.div`
  font-size: 14px;
`;

const UnorderList = styled.ul`
  list-style-type: none;
  padding-left: 0;

  li {
    position: relative;
    padding-left: 50px;
    margin-bottom: 10px;
  }

  li:before {
    content: "•";
    font-size: 40px;
    position: absolute;
    left: 10px;
    top: -22px;
  }

  li:nth-child(1):before {
    color: #4ade80;
  }

  li:nth-child(2):before {
    color: #3b82f6;
  }

  li:nth-child(3):before {
    color: #6b7280;
  }
`;

const DescriptionTextThree = ({ name, t }) => {
  switch (name) {
    case "Klimat":
      return (
        <>
          <Description>
            {t("Klimatpoängen inkluderar livsmedlens klimatpåverkan inklusive förpackning fram till och med råvarans eventuella förädling i industri. Transport från industri, via eventuell grossist, och till organisation som ska tillaga måltiden är alltså inte inkluderad. Undantag är gjorda för importerade produkter där ett klimatbidrag för en generellt antagen transport till Sverige är adderad till den totala klimatpoängen.")}
          </Description>
        </>
      );
    case "Social rättvisa":
      return (
        <>
          <Description>
            {t("Den tyska Bertelsmannstiftelsen publicerar årligen ett socialt rättviseindex där 41 EU och OECD-länder rankas mot varandra.")}
          </Description>
          <DivSection>
            {t("Indexet bygger på 46 indikatorer fördelade på sex huvudkategorier:")}
            <ul style={{ fontSize: "16px" }}>
              <li>{t("Fattigdomsbekämpning")}</li>
              <li>{t("Tillgång till utbildning")}</li>
              <li>{t("Tillgång till arbetsmarknaden")}</li>
              <li>{t("Hälsa")}</li>
              <li>{t("Rättvisa förhållanden mellan generationerna")}</li>
              <li>{t("Social sammanhållning och icke-diskriminering")}</li>
            </ul>
          </DivSection>
          <Description>
            {t("En högre siffra innebär att landet blivit mer socialt rättvist medan en lägre visar att det blivit mindre socialt rättvist.")}
          </Description>
        </>
      );
    case "Vatten":
      return (
        <>
          <Description>
            {t("Vattenfotavtrycket speglar den totala mängd vatten som krävs för att producera ett kilo av livsmedlet. Vi använder oss av Water Footprint Networks beräkningar av vattenfotavtryck som tar hänsyn till tre typer av vatten som krävs för att producera en vara.")}
          </Description>

          <Description>
            {t("Ur ett miljöperspektiv är grönt vatten det bästa att använda i produktionen följt av blått. Grått ska man däremot försöka minska eller helt undvika.")}
          </Description>
          <DivSection>
            <UnorderList>
              <li>
                {t("Grönt: vatten från nederbörd och dagg som lagras i området kring rötterna i odlingsjorden och som avdunstar, utsöndras och tas upp av plantor. Det är speciellt relevant för jordbruk, odling och skogsbruk.")}
              </li>
              <li className="my-4">
                {t("Blått: vatten som har pumpats upp från yt- eller grundvattenkällor och som antingen avdunstar, tas upp i en produkt eller tas från en vattenkälla och returneras till en annan, vid samma eller annat tillfälle. Bevattnat jordbruk, industri och bostäder kan alla ha ett blått vattenfotavtryck.")}
              </li>
              <li>
                {t("Grått: den mängd färskvatten som behövs för att späda ut föroreningar så mycket att vissa krav på vattnets kvalitet uppfylls. Det grå vattenfotavtrycket tar i beaktande direkta utsläpp genom avlopp eller indirekt genom avrinning, genomrinning av jord, överspolning etc.")}
              </li>
            </UnorderList>
          </DivSection>
        </>
      );
    case "Transport":
      return (
        <>
          <Description>
            {t("När du väljer produkter med höga värden, istället för låga, i denna kategori kommer din mat ha färdats kortare sträckor för att nå Sverige. Matvaror producerade i Sverige kommer att ha högst poäng. Du bidrar också till FN:s hållbarhetsmål 13 (bekämpa klimatförändringarna).")}
          </Description>
        </>
      );
    case "Landanvändning":
      return (
        <>
          <Description>
            {t("När du väljer produkter med höga värden, istället för låga, i denna kategori främjar du mat som behöver mindre landyta för att produceras. Du bidrar också till flera av FN:s hållbarhetsmål såsom 2 (Ingen hunger), 12 (Hållbar konsumtion och produktion), 13 (Bekämpa klimatförändringarna) och 15 (Ekosystem och biologisk mångfald).")}
          </Description>

          <Description>
            {t("Enligt data från FN:s livsmedels- och jordbruksorganisation (FAO) används mer än hälften av jordens beboeliga landyta till jordbruk. I takt med att människan använder mer och mer landyta för matproduktion förlorar andra arter sina naturliga habitat i allt högre utsträckning.")}
          </Description>

          <Description>
            {t("Poängen beräknas utifrån resultat i den vetenskapliga publikationen Poore, J., & Nemecek, T. (2018). Reducing food's environmental impacts through producers and consumers.")}
          </Description>
        </>
      );
    case "Bekämpningsmedel":
      return (
        <>
          <Description>
            {t("Värdet visar hur mycket bekämpningsmedel som används för att producera produkten och beräknas av Consupedia utifrån FAO:s statistik . Värdet anges på en skala från 1–100. Ju högre värde, desto mindre användning av bekämpningsmedel i produktionslandet.")}
          </Description>

          <Description>
            {t("När du väljer produkter med höga värden, istället för låga, i denna kategori är det lägre risk att skadliga kemikalier använts i framställandet av din mat. Du bidrar även till flera av FN hållbarhetsmål såsom 3 (God hälsa och välbefinnande), (Rent vatten och sanitet för alla), 8 (Anständiga arbetsvillkor och ekonomisk tillväxt), 12 (Hållbar konsumtion och produktion), 14 (Hav och marina resurser) och 15 (Ekosystem och biologisk mångfald).")}
          </Description>
        </>
      );
    case "Övergödning":
      return (
        <>
          <Description>
            {t("Värdet beräknas av Consupedia utifrån FAO:s statistik. Värdet anges på en skala från 1–100.")}
            {t("När du väljer produkter med höga värden, istället för låga, i denna kategori löper din konsumtion lägre risk att bidra till övergödning av miljön. Du bidrar också till flera av FN:s hållbarhetsmål såsom 6 (Rent vatten och sanitet för alla), 8 (Anständigt arbete och ekonomisk tillväxt), 12 (Hållbar konsumtion och produktion), 13 (Bekämpa klimatförändringarna), 14 (Hav och marina resurser) och 15 (Ekosystem och biologisk mångfald). 4 (Life Below Water) och 15 (Ekosystem och biologisk mångfald).")}
          </Description>
        </>
      );
    case "Barnarbete":
      return (
        <>
          <Description>
            {t("När du väljer produkter med höga värden, istället för låga, i denna kategori minskar du risken att barnarbete varit en del av produktionen av din mat och du stödjer handel med länder med låg risk för barnarbete. Du bidrar dessutom till flera FN:s hållbarhetsmål såsom 3 (God hälsa och välbefinnande) 8 (Anständig arbetsmiljö och ekonomisk tillväxt) 10 (Minskad ojämlikhet), 12 (Hållbar konsumtion och produktion).")}
          </Description>
        </>
      );
    case "Djurvälfärd":
      return (
        <>
          <Description>
            {t("Organisationen World Animal Protection rankar varje år 50 länder runtom i världen utifrån hur deras lagar och regler kring djurskydd ser ut. Consupedias värde är beräknat utifrån detta Animal Protection Index. World Animal Protection är en global ideell organisation som arbetar för att stärka djurskyddet.")}
          </Description>

          <Description>
            {t("När du väljer produkter med höga värden, istället för låga, i denna kategori har djuren som varit involverade i produktionen av din mat varit bättre skyddade genom lagar och förordningar än djur i länder med lägre poäng i kategorin. Även om det inte finns hållbarhetsmål från FN som är specifikt riktade mot djurvälfärd så så påverkar du indirekt flera andra av hållbarhetsmålen såsom 12 (hållbar konsumtion och produktion) och 14 (hav och marina resurser) med dina val i den här kategorin.")}
          </Description>
        </>
      );
    case "Arbetsförhållanden":
      return (
        <>
          <Description>
            {t("Consupedia anger produktionslandets värde från Amforis årliga rapport, en internationell medlemsorganisation för transparent och hållbar handel. Värdet bygger på Världsbankens indikatorer för styrning (eng. governance): Voice and Accountability, Political Stability and Absence of Violence/Terrorism, Government Effectiveness, Regulatory Quality, Rule of Law.")}
          </Description>

          <Description>
            {t("När du väljer livsmedel med höga poäng i den här kategorin är det mindre troligt att din mat producerats under dåliga arbetsförhållanden. Du främjar också handel med länder med bättre arbetsförhållanden och bidrar till flera av FN hållbarhetsmål såsom 3 (God hälsa och välbefinnande), (Anständiga arbetsvillkor och ekonomisk tillväxt), 10 (Minskad ojämlikhet), 12 (Hållbar konsumtion och produktion), 16 (Fredliga och inkluderande samhällen).")}
          </Description>
        </>
      );
    case "Biologisk mångfald":
      return (
        <>
          <Description>
            {t("Människans produktion av livsmedel har en skadlig effekt på den biologiska mångfalden. Antalet arter i växt- och djurliv sjunker kraftigt till följd av bekämpningsmedel, växtskyddsmedel, monokulturer, förändring av markområden (t.ex. avskogning), utfiskning och fiskeredskap som förstör havsbotten.")}
          </Description>
          <Description>
            {t("EPI (Environmental Performance Index) rankar 180 länder utifrån deras nationella åtgärder för att skydda miljön, stärka ekosystemen och minska klimatförändringar. Rankingen baseras på 40 indikatorer (t.ex. ökade utsläpp av växthusgaser) som är indelade i 11 kategorier (t.ex. klimatförändring).")}
          </Description>

          <Description>
            {t("Consupedias värde för biologisk mångfald vilar på data från kategorin Biodiversitet och Livsmiljö (Biodiversity & Habitat). EPI tas årligen fram av de amerikanska universiteten Yale och Columbia tillsammans med den schweiziska stiftelsen World Economic Forum.")}
          </Description>

          <Description>
            {t("När du väljer produkter med höga värden, istället för låga, i denna kategori hjälper du till att bevara den biologiska mångfalden. Du bidrar också till FN:s hållbarhetsmål 13 (Bekämpa klimatförändringarna), 14 (Hav och marina resurser) och 15 (Ekosystem och biologisk mångfald).")}
          </Description>
        </>
      );
    case "Jämlikhet":
      return (
        <>
          <Description>
            {t("Källan till Consupedias värdering är Bertelsmann-stiftelsens index för social rättvisa. I detta index undersöks sex olika dimensioner av social rättvisa: fattigdom, utbildning, arbetsmarknad, rättvisa för olika generationer, hälsa, samt social inklusion och icke-diskriminering.")}
          </Description>

          <Description>
            {t("Consupedias jämlikhetsparameter baseras på dimensionen social inklusion och icke-diskriminering. Bertelsmann-stiftelsen är en oberoende tysk stiftelse vars syfte bland annat är att främja forskning och vetenskap, kultur och utbildning. När du väljer produkter med höga värden, istället för låga, i denna kategori gynnar du länder med mer jämlika förhållanden. Du bidrar också till flera av FN:s hållbarhetsmål såsom 1 (Ingen fattigdom), (Ingen hunger), 3 (God hälsa och välbefinnande), 4 (God utbildning), 8 (Anständiga arbetsvillkor och Ekonomisk tillväxt), 10 (Minskad ojämlikhet), 16 (Fredliga och Inkluderande samhällen).")}
          </Description>
        </>
      );
    case "Lokalbefolkning":
      return (
        <>
          <Description>
            {t("Consupedias poäng bygger på produktionslandets värde i en årlig rapporten från Amfori, en internationell medlemsorganisation för transparent och hållbar handel. Värdet anges på en skala från 1–100, ju högre poäng, desto mindre troligt att din mat producerats i rättsosäkra samhällen. Du främjar också handel med länder med bättre rättssäkerhet och bidrar till flera av FN:s hållbarhetsmål såsom 3 (God hälsa och välbefinnande), 8 (Anständiga arbetsvillkor och ekonomisk tillväxt), 10 (Minskad ojämlikhet), 12 (Hållbar konsumtion och produktion), 16 (Fredliga och inkluderande samhällen).")}
          </Description>
        </>
      );
    default:
      return "";
  }
};

export default DescriptionTextThree;
